import { FC } from "react";
import ExperiencesPage from "./ExperiencesPage";

const ExperiecesWrapper: FC = () => {
  return (
    <div>
      <ExperiencesPage />
    </div>
  )
}

export { ExperiecesWrapper }